export const ATTENDEE_ID_KEY_IN_LINE_ITEM_METADATA = 'attendeeId'
export const PRODUCT_FORM_ID_IN_LINE_ITEM_METADATA = 'productFormId'
export const VARIANT_ID_KEY_IN_LINE_ITEM_METADATA = 'variantId'
export const TYPE_KEY_IN_LINE_ITEM_METADATA = 'type'
export const KEY_CART_IN_LOCALSTORAGE = 'storeCartId'
export const PRODUCT_FORM_VALUE_IN_TYPE_LINE_ITEM = 'PRODUCT_FORM'
export const COMPETITION_PASS_TYPE_LINE_ITEM = 'COMPETITION_PASS'
export const FEES_FORM_VALUE_IN_TYPE_LINE_ITEM = 'FEES'
export const RELAY_SHARE_ID_KEY_IN_LINE_ITEM_METADATA = 'shareId'
export const ATTENDEES_GRID_STATE = 'attendeesGridState'
export const TRACKING_KEY_IN_COOKIE = '__utmzz'
export const AVOID_LINE_ITEM_MERGE_ID_KEY = 'avoidLineItemMergeId'
export const CANCELATION = 'cancelation'
export const REFUND = 'refund'
export const ADMIN_REFUND = 'adminRefund'
export const GENERIC_FEES = 'genericFees'
export const RACE_SWAP = 'RACE_SWAP'
export const PARTIAL_CANCELATION = 'PARTIAL_CANCELATION'
export const DISCOUNT_CANCELLATION = 'DISCOUNT_CANCELLATION'
export const INVISIBLE_BALANCING = 'INVISIBLE_BALANCING'
export const PARTNER_OPTION_VALUE_IN_TYPE_LINE_ITEM = 'PARTNER_OPTION'
export const OPTIONS_SWAP = 'OPTIONS_SWAP'
export const RACE_ID = 'raceId'
export const PRERESERVED_KEY_IN_LINE_ITEM_METADATA = 'PRERESERVED'
